/*
// see storageUtil for hiding fav items
*/
define('gxp',[
  'jquery',
  'lib/util/tda.config',
  'cookies',
  'lib/getParameterByName',

  // side effect includes
  'bat',
  'storageUtil', // Keep using SU on window
  'zipTools' // keep using window.zipTools below
], function (
  $,
  tdaConfig,
  cookies,
  getParameterByName
) {
  var __int = ['preview', 'national-preview', 'staging', 'national-staging'];
  var __stage = ['test', 'localhost'];
  var __test = ['national-dev'];

  var gxpBat = gxpBat || {
    getEnviron: function getEnviron() {
      var parts = window.location.hostname.split('.');
      var subdomain = parts.shift();

      if (__int.indexOf(subdomain) > -1) {
        return 'int';
      }
      if (__stage.indexOf(subdomain) > -1) {
        return 'stage';
      }
      if (__test.indexOf(subdomain) > -1) {
        return 'test';
      }
      return 'prod';
    },

    dgCDN: function dgCDN() {
      // return vals match that found in fixed-layout in LSDS
      var env = this.getEnviron();
      if (env === 'int') return 'https://cdn.dgint.deops.toyota.com';
      if (env === 'stage') return 'https://cdn.dgstage.deops.toyota.com';
      if (env === 'test') return 'https://cdn.dgtest.deops.toyota.com';
      return 'https://cdn.dg.toyota.com';
    },

    rticCDN: function rticCDN() {
      // return vals match that found in fixed-layout in LSDS
      var env = this.getEnviron();
      if (env === 'int') return 'https://cdn.rticint.deops.toyota.com';
      if (env === 'stage') return 'https://cdn.rticstage.deops.toyota.com';
      if (env === 'test') return 'https://cdn.rtictest.deops.toyota.com';
      return 'https://cdn.rtic.toyota.com';
    },

    // return azureClientId based on environment in URL
    getAzureClientId: function () {
      var parts = window.location.hostname.split('.');
      var subdomain = parts.shift();
      var idPreproduction = '061a2c23-9429-4172-abaf-81e1b9ee15a0';
      var idProduction = '183ec5eb-abf3-4430-9451-9fad08ce61d4';
      var preprod = ['dev', 'test'];
      if (preprod.indexOf(subdomain) > -1) {
        return idPreproduction;
      }
      return idProduction;
    },
    participants: ['CIN10', 'DVR10', 'KAC10', 'WWW'],
    garage: {
      isOffersModal: false,
      isInventoryModal: false,
      init: function () {
        // Does user have a dealer_code_rti cookie whose value is true?
        if (cookies.getItem('dealer_code_rti_code_transfer')) {
          // console.log('GXP Garage: Found transfer cookies, use those');
          var dcTransfer = cookies.getItem('dealer_code_rti_code_transfer');
          var fmpTransfer = cookies.getItem('dealer_code_fmp_transfer');
          var rtiTransfer = cookies.getItem('dealer_code_rti_transfer');
          var tdaTransfer = cookies.getItem('dealer_code_tda_transfer');
          var urlTransfer = cookies.getItem('dealer_url_transfer');
          window.fmp.setDealerCookies(dcTransfer, fmpTransfer, rtiTransfer, tdaTransfer, urlTransfer);
          cookies.removeItem('dealer_code_rti_code_transfer', '/', window.zipTools.getCrossDomainCookieDomain());
          cookies.removeItem('dealer_code_fmp_transfer', '/', window.zipTools.getCrossDomainCookieDomain());
          cookies.removeItem('dealer_code_rti_transfer', '/', window.zipTools.getCrossDomainCookieDomain());
          cookies.removeItem('dealer_code_tda_transfer', '/', window.zipTools.getCrossDomainCookieDomain());
          cookies.removeItem('dealer_url_transfer', '/', window.zipTools.getCrossDomainCookieDomain());
        };
        // Always try and set the DealerCode to what's in the URL. This will allow us to spot a deep link.
        // it will trigger the garage based change.
        var dealer_code = getParameterByName('dealerCd') || cookies.getItem('dealer_code_rti_code');
        var dealer_code_tda = cookies.getItem('dealer_code_tda');
        var dealer_code_rti = cookies.getItem('dealer_code_rti');
        var batSeries = $('#offer-detail').data('series');
        // console.log('GXP Garage: Checking if user has saved RTI dealer_code');
        if (dealer_code_rti === 'true' && dealer_code_tda === SU.getTDA()) {
          // console.log('GXP Garage: RTI dealer present! Use dealerCd from dealer_code_rti_code cookie');
          // update existing window.DGDataHub that are already output in our XSLs (offer-details pages)
          if ( window.DGDataHub && typeof batSeries != 'undefined' ) {
            // console.log('GXP Garage: DGDataHub in DOM (via XSL) update it.')
            window.DGDataHub.Deploy_Env = gxpBat.getEnviron(),
            window.DGDataHub.dealerCd = dealer_code;
            window.DGDataHub.saveItem = window.DGDataHub.saveItem || gxpBat.garage.tmpSaveitem;
            window.DGDataHub.saveItem.dealerCd = dealer_code; // specific to the offer details pages
            window.DGDataHub.saveItem.viewInvHref = window.location.origin + window.zipTools.getSiteHomePath() + 'inventory/search/?series=' + batSeries; // absolute URL  to inventory
            window.DGDataHub.saveItem.viewSimilarOffersHref = window.location.origin + window.zipTools.getSiteHomePath() + 'offers/' + batSeries + '/index.page'; // absolute link to similar offers
            window.DGDataHub.saveItem.disclaimers = window.DGDataHub.saveItem.disclaimers.filter(String); // clean strings
            window.DGDataHub.spaRoot = '/' + tdaConfig.site.context_url + '/saves';
            window.DGDataHub.components = {'dg-nav-menu': {'version': '1-0'}};

            if (window.DGDataHub.saveItem.offerType == 'msrp' || window.DGDataHub.saveItem.offerType == 'misc' || window.DGDataHub.saveItem.offerType == 'multi') {
              // console.log('GXP: unsupported offerType of ' + window.DGDataHub.saveItem.offerType + ', removed saveItem');
              delete window.DGDataHub.saveItem;
            }

          // else, current page doesn't have a window.DGDataHub, let's add one
          } else {
            // console.log('GXP Garage: DGDataHub NOT in DOM (via XSL). Add one.')
            window.DGDataHub = {
              DEPLOY_ENV: gxpBat.getEnviron(),
              dealerCd: dealer_code,
              spaRoot:  '/' + tdaConfig.site.context_url + '/saves',
              components: {'dg-nav-menu': {'version': '1-0'}}
            }
          }
          // we always need this. This is the garage checking to see if current cookie matches w/ the
          // dealer_code that we just set!
          window.DGDataHub.loadNewDealer = function (garageDealerCode, garageZipCode) {
            // User selected NO, (NO THANKS) do not update dealer. Which means, keep whatever dealer/zip was in their garage.
            // We need to check the TDA of this newZip. Here's the callback for after
            var temp = new Date();
            temp.setSeconds(temp.getSeconds() + 30); // 30 seconds for our temp cookie
            cookies.setItem('dealer_gxp_fmp_Entered', String(true), temp, '/', window.zipTools.getCrossDomainCookieDomain()); //
            var checkTDACallback = function (data) {
              // console.log('GXP: User has chosen to KEEP cookied dealer via garage warning. ' + garageDealerCode + ' dealer zip kept: ' + garageZipCode);
              var currentTDACode = window.zipTools.getCurrentTDACode();
              var newTDACode = data.entityList[0].tdaCode;
              // console.log('GXP: Check dealerCode TDA');
              // buildInventoryUrlRti handles any TDA change if needed
              // showLoader
              // set dealer cookies no matter what
              window.fmp.setDealerCookies(garageDealerCode, false, true, newTDACode, '');
              if (currentTDACode !== newTDACode) {
                window.fmp.setDealerTransferCookies(garageDealerCode, false, true, newTDACode, '');
              }
              var promisedSeries = window.fmp.buildInventoryUrlRti();
              promisedSeries.done(function (rtiUrl) {
                if (currentTDACode !== newTDACode) {
                  var rtiUrlStr = rtiUrl;
                  var rtiUrlStr = rtiUrlStr.replace('zipcode=null', 'zipcode=' + garageZipCode);
                  window.zipTools.changeZip(SU.getZip(), garageZipCode, rtiUrlStr, undefined, true, false);
                } else {
                  if (rtiUrl !== '') {
                    window.location.href = rtiUrl;
                  }
                  // else console.log('GXP: Auto-saved dealer is RTI. Already on proper page. Stop.');
                }
              });
            };

            // check TDA of this new Zip
            window.zipTools.getTDA(garageZipCode, checkTDACallback);
            // Just change the zip to this saved one? AND set dealer cookies!?
          }
          window.DGDataHub.continuePageLoad = function () {
            // If there is no need/opportunity to select a dealer in the zip code, then there is no need to do anything here
            // If there is a need/opportunity to select a dealer in the zip code, launch the dealer select modal
            // If this is a deep-link dealer conflict on an inventory page, you may continue loading content on the page
            var dealerCode = getParameterByName('dealerCd');
            var zipCode = getParameterByName('zipcode') || SU.getZip();
            var isGxpEntryPage = window.location.href.indexOf('inventory/results') > -1 || window.location.href.indexOf('inventory-detail') > -1 || window.location.href.indexOf('local-results') > -1 ;
            // if saved dealer code doesn't match that in the URL, then user has elected to switch to this new dealerCd
            if (window.DGDataHub.dealerCd !== cookies.getItem('dealer_code_rti_code')) {
              // console.log('GXP: Continue page load. user has elected to update their dealer & dealer codes do NOT match');
              var callBack = function () {
                window.DGDataHub.changeActiveDealer(dealerCode);
              }
              window.zipTools.changeZip(SU.getZip(), zipCode, '', callBack, true, false);

            // if this is a NON GXP page (GXP entry page), the user needs to be prompted (deep linked pages)
            } else if (isGxpEntryPage) {
              // This means there's a need/opportunity to change the zip here
              window.zipTools.changeZip(SU.getZip(), zipCode, '', callBack, true, false);
            }
          };
          this.getDGScripts();
        // if no cookie (OR cookie from other TDA!!!)
        } else {
          // if this is offer-details page, use gelocation to get zip (or prompt if no geolocate) and then force user to select dealer (need to find if this is GXP participant)
          var isOfferDetail = window.location.href.indexOf('offer-detail') > -1;
          var currentZip = SU.getZip();
          var suggestedZip = currentZip;
          var batSeries = $('#offer-detail').data('series');
          // console.log('GXP Garage: No RTI dealer present. Add window.DGDataHub dealerCd: "Toyota", then the scripts, and let garage do the checking on its own.');
          // if this page has a saveItem, let's add that wether we use it NOW or not (allows us to NOT refresh the offer details page)
          gxpBat.garage.tmpSaveitem = isOfferDetail ? window.DGDataHub.saveItem : {};
          // manually update props that aren't set in xsl
          gxpBat.garage.tmpSaveitem.viewInvHref = window.location.origin + window.zipTools.getSiteHomePath() + 'inventory/search/?series=' + batSeries; // absolute URL  to inventory
          gxpBat.garage.tmpSaveitem.viewSimilarOffersHref = window.location.origin + window.zipTools.getSiteHomePath() + 'offers/' + batSeries + '/index.page'; // absolute link to similar offers

          window.DGDataHub = {
            DEPLOY_ENV: gxpBat.getEnviron(),
            dealerCd: 'Toyota',
            spaRoot:  '/' + tdaConfig.site.context_url + '/saves',
            components: {'dg-nav-menu': {'version': '1-0'}},
            /* The page's current dealer can also be required to change. In the scenario where the user lands on the page with a Garage Dealer different from the page dealer and selects to keep the current dealer of the Digital Garage when prompted (Prompt initiated from garage).
            Because this is a garage-initiated change in active dealer, the page needs to listen for this specific event. The page should refresh and do any logic it needs to perform to switch to the garage dealer. Host sites can listen for these events by defining a function in DGDataHub called loadNewDealer. This function will be passed two parameters, garageDealerCode and garageZipCode */
            loadNewDealer: function (garageDealerCode, garageZipCode) {
              // We need to check the TDA of this newZip. Here's the callback for after
              var temp = new Date();
              temp.setSeconds(temp.getSeconds() + 30); // 30 seconds for our temp cookie
              cookies.setItem('dealer_gxp_fmp_Entered', String(true), temp, '/', window.zipTools.getCrossDomainCookieDomain());
              var checkTDACallback = function (data) {
                // console.log('GXP: User has chosen to KEEP cookied dealer via garage warning. ' + garageDealerCode + ' dealer zip kept: ' + garageZipCode);
                var currentTDACode = window.zipTools.getCurrentTDACode();
                var newTDACode = data.entityList[0].tdaCode;
                // console.log('GXP: Check dealerCode TDA');
                // buildInventoryUrlRti handles any TDA change if needed
                // showLoader
                if (currentTDACode !== newTDACode) {
                  window.fmp.setDealerTransferCookies(garageDealerCode, false, true, newTDACode, '');
                } else {
                  window.fmp.setDealerCookies(garageDealerCode, false, true, newTDACode, '');
                }
                var promisedSeries = window.fmp.buildInventoryUrlRti();
                promisedSeries.done(function (rtiUrl) {
                  if (currentTDACode !== newTDACode) {
                    var rtiUrlStr = rtiUrl;
                    var rtiUrlStr = rtiUrlStr.replace('zipcode=null', 'zipcode=' + garageZipCode);
                    window.zipTools.changeZip(SU.getZip(), garageZipCode, rtiUrlStr, undefined, true, false);
                  } else {
                    window.zipTools.updateZipFields(garageZipCode);
                    SU.setZip(garageZipCode);
                    SU.setConfirmedZip(true);
                    // SU.initFavorites(); // re-check BAT favorites
                  }
                });
              };

              // check TDA of this new Zip
              window.zipTools.getTDA(garageZipCode, checkTDACallback);
              // Just change the zip to this saved one? AND set dealer cookies!?
            },
            continuePageLoad: function () {
              // If there is no need/opportunity to select a dealer in the zip code, then there is no need to do anything here
              // If there is a need/opportunity to select a dealer in the zip code, launch the dealer select modal
              // If this is a deep-link dealer conflict on an inventory page, you may continue loading content on the page

              // if series param AND dealer_code are in URL, use those to changeActiveDealer
              var page = window.location.search;
              var dealerCode = getParameterByName(page, 'dealerCd');
              var zipCode = getParameterByName(page, 'zipcode');
              if (window.DGDataHub.dealerCd === 'Toyota' && dealerCode) {
                window.fmp.setDealerCookies(dealerCode, false, true, SU.getTDA(), undefined);
                var callBack = function () {
                  window.DGDataHub.changeActiveDealer(dealerCode);
                }
                window.zipTools.changeZip(SU.getZip(), zipCode, '', callBack, true, false);

              // if this is an offer details page, and we have a 'Toyota' garage && no dealerCode
              // then use confirmed zip if available, OR geolocoate or prompt for zip
              } else if (isOfferDetail && (dealer_code_rti == null)) {
                // console.log('GXP Garage: offer detail page. User has not selected a dealer before.');
                var isZipConfirmed = window.zipTools.verifyConfirmedZip();
                if (isZipConfirmed) {
                  window.zipTools.changeZip(SU.getZip(), SU.getZip(), '', undefined, false, false, true);
                } else {
                  window.fmp.getZipFromLocate = function () {
                    var failCallback = function () {
                      window.zipTools.showPromptUserZipModal(currentZip, suggestedZip, '', undefined, true, false, false, true);
                    };
                    try {
                      if (navigator.geolocation) {
                        // try geolocation
                        // detect zip, provide successCallbak and failCallback
                        var geoSuccess = function (responseZip) {
                          var currentZip = SU.getZip();
                          window.zipTools.changeZip(currentZip, responseZip, '', undefined, false, false, true);
                        };
                        window.zipTools.geoLocationZip.detect(geoSuccess, failCallback);
                      } else {
                        failCallback();
                      }
                    } catch (e) {
                      // console.log('try failed ', e);
                      failCallback();
                    }
                  };
                  window.fmp.getZipFromLocate();
                  // end geolocate / get zip bits
                }
              }
            }
          }
          this.getDGScripts();
        }
      },

      // Triggered from zipTools.changeZip when RTI participating dealer is present
      // or when changing zip on an GXP Entry point page (inventory/results or inventory/details)
      zipFlowEnter: function () {
        $(window).on('ZIP_CODE_RTI_FLOW_ENTER', function (event, changeZipData) {
          // changeZipData.currentZip // this is the zip we were just changing from. Will need this in case user cancels
          var dealer_code_rti = cookies.getItem('dealer_code_rti');
          var dealer_code_fmp = cookies.getItem('dealer_code_fmp');
          var dealer_code = cookies.getItem('dealer_code_rti_code');
          var oneYear = new Date(Date.now() + (365 * 24 * 60 * 60 * 1000));
          var temp = new Date();
          temp.setSeconds(temp.getSeconds() + 60); // 60 seconds for our temp cookie
          var isInventoryModal;
          var isOffersModal;
          if (window.location.href.indexOf('offer-detail') > -1) {
            isOffersModal = true;
            window.gxpBat.garage.isOffersModal = true;
            changeZipData.isOffersModal = true;
            isInventoryModal = false;
            window.gxpBat.garage.isInventoryModal = false;
            changeZipData.isInventoryModal = false;
          } else {
            isOffersModal = false;
            window.gxpBat.garage.isOffersModal = false;
            changeZipData.isOffersModal = false;
            isInventoryModal = true;
            window.gxpBat.garage.isInventoryModal = true;
            changeZipData.isInventoryModal = true;
          }
          var checkNewDealerAfterZipChange = function () {
            // var newzip = SU.getZip(); // recently confirmed zip
            // console.log('GXP: final callback');
          };

          // User has an RTI participating dealer!
          if (dealer_code_rti === 'true') {
            // console.log('GXP: User has an RTI dealer selected');
            // var hasItemsInGarage = window.DGDataHub.getItemCount(); // GXP API, see if use has any saved items
            // 1: Remove dealer_code_rti cookie so we can carry on with the zip change process
            cookies.setItem('dealer_code_rti_code_temp', String(dealer_code), temp, '/', window.zipTools.getCrossDomainCookieDomain());
            cookies.removeItem('dealer_code_rti', '/', window.zipTools.getCrossDomainCookieDomain());
            /*----------------------------------------------------------
            User has items in their garage.
            invoke warning via  GXP API: window.DGDataHub.showDealerWarning(continueCallback, cancelCallback)
            because changing zip MAY mean they lose their garage
            ----------------------------------------------------------*/
            // if (hasItemsInGarage > 0){
            // console.log('GXP Garage: Request interstitial');
            // "yes, change zip code (and thereby, current dealer)"
            var gxpChangeContinue = function () {
              // console.log('GXP Garage: Continue with zip change to: ', changeZipData.newZip);
              // window.fmp.firstMoverParticipantDisplay(newZip, newDealer, 1, 5, SU.getTDA(), true, false);
              window.zipTools.changeZip(changeZipData.currentZip, changeZipData.newZip, changeZipData.redirectPath, checkNewDealerAfterZipChange, changeZipData.isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal)
            }

            // "no, keep current dealer. Reset dealer_code cookie!"
            var gxpChangeCancel = function () {
              // console.log('GXP: Keep current Dealer');
              cookies.setItem('dealer_code_rti', String('true'), oneYear, '/', window.zipTools.getCrossDomainCookieDomain());
              cookies.removeItem('dealer_code_rti_code_temp', '/', window.zipTools.getCrossDomainCookieDomain());
              window.zipTools.updateZipFields(changeZipData.currentZip);

              var isGxpEntryPage = window.location.href.indexOf('inventory/results') > -1 || window.location.href.indexOf('inventory-detail') > -1 || window.location.href.indexOf('local-results') > -1 ;
              if (isGxpEntryPage) {
                // console.log('GXP: Keep current Dealer. From a deep link non-GXP entry point page. redirect to GXP page');
                var promisedSeries = window.fmp.buildInventoryUrlRti();
                promisedSeries.done(function (rtiUrl) {
                  if (rtiUrl !== '') {
                    window.location.href = rtiUrl;
                  }
                  // else console.log('GXP: Returned URL was empty');
                });
              }
            };
            // Show GXPs 'Dealer Change' warning, providing continue and cancel callbacks
            window.DGDataHub.showDealerWarning(gxpChangeContinue, gxpChangeCancel);

            /*
             // user has NO items in garage. Carry on with changeZip
            } else {
              console.log('GXP Garage: No items saved in garage, carry on');
              window.zipTools.changeZip(changeZipData.currentZip, changeZipData.newZip, changeZipData.redirectPath, checkNewDealerAfterZipChange, changeZipData.isSkipConfirmZipChangeModal, true)
            }
            */
          } else if (dealer_code_fmp === 'true') {
            // console.log('GXP: User has an FMP dealer selected');
            cookies.setItem('dealer_gxp_fmp_Entered', String(true), temp, '/', window.zipTools.getCrossDomainCookieDomain());
            window.zipTools.changeZip(changeZipData.currentZip, changeZipData.newZip, changeZipData.redirectPath, checkNewDealerAfterZipChange, changeZipData.isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal)
            /*----------------------------------------------------------
            User is BOTH: On an RTI (or FMP) entry point page
            AND has a selected non dealer_code_rti dealer OR no selected dealer at all
            // use a dealer_gxpEntered temp cookie so our changeZip flow knows that we've just entered via GXP entry point
            ------------------------------------------------------------*/
          } else {
            cookies.setItem('dealer_gxp_fmp_Entered', String(true), temp, '/', window.zipTools.getCrossDomainCookieDomain());
            // console.log('GXP Garage: Changing zip on a GXP entry point, without a selected dealer (or with a non particiapting dealer)');
            window.zipTools.changeZip(changeZipData.currentZip, changeZipData.newZip, changeZipData.redirectPath, checkNewDealerAfterZipChange, changeZipData.isSkipConfirmZipChangeModal, isInventoryModal, isOffersModal)
          }
        });
      },

      // add scripts that are required for our garage
      getDGScripts: function () {
        var savesPage = window.location.href.indexOf('/saves/') > -1;
        var offersIframe = window.location.href.indexOf('/dealer_offers_frame/') > -1;
        if (offersIframe) { return; } // don't display garage if on offers iframe
        var script = gxpBat.dgCDN() + '/deploy/dg-library/latest/deploy/dg-app.min.js';
        if (savesPage) {
          script = gxpBat.dgCDN() + '/deploy/dg-pages/1-0/dg-spas-main.min.js';
        }
        $.when(
          $.getScript(script),
          $.Deferred(function (deferred) {
            $(deferred.resolve);
          })
        ).done(function () {
          window.bat.util.loader.hideLoader();
        }).always(function (response) {
          console.log('getDGScripts response: ', response);
        });

        // main nav widget script
        $.when(
          $.getScript(gxpBat.dgCDN() + '/deploy/dg-components/1-0/dg-component-main.min.js'),
          $.Deferred(function (deferred) {
            $(deferred.resolve);
          })
        ).done(function () {
          // init main nav piece
        }).always(function (response) {
          console.log('main nav component script: ', response);
        });
      }
    },

    /*-------------------------------------------------------------------------------------
    /gxp/inventory-search page.
    User will not end up on this GXP search page unless they've already
    set a dealer_code cookie AND its RTI, so its safe to just use our dealer_code cookie
    ---------------------------------------------------------------------------------------*/
    RCsearch: {
      triggerZipModal: function() {
        window.zipTools.showPromptUserZipModal(SU.getZip(), SU.getZip(), undefined, '', true, true);
      },

      init: function() {
        window.bat.util.loader.showLoader();
        // console.log('GXP RC: Found reusable search component, update viewConfig with data from URL');
        // reusable component viewConfig object, required on page before bundle.js
        var dealerCode = cookies.getItem('dealer_code_rti_code') || getParameterByName('dealerCd');
        window.viewConfig = {
          dealerCd: dealerCode,
          series: getParameterByName('series') ? getParameterByName('series') : '',
          detailsRoute: tdaConfig.site.context_url + '/inventory/details/',
          zipcode: SU.getZip(),
          env: gxpBat.getEnviron(),
          backToVehiclesPath: window.zipTools.getSiteHomePath() + 'inventory/',
          selectedModels: getParameterByName('selectedModels') ? getParameterByName('selectedModels') : '', // 'camry le, etc'
          extColor: getParameterByName('extColor') ? getParameterByName('extColor') : '',
          packagesAccessories: getParameterByName('packagesAccessories') ? getParameterByName('packagesAccessories') : '',
          engineAndTransmission: getParameterByName('engineAndTransmission') ? getParameterByName('engineAndTransmission') : '',
          priceMin: getParameterByName('priceMin') ? getParameterByName('priceMin') : '',
          priceMax: getParameterByName('priceMax') ? getParameterByName('priceMax') : '',
          zipModalHook: this.triggerZipModal,
          campaignCodes: {
            dealerDesktop: 'TXBT36350000',
            dealerMobile: 'TXBT36350001',
            priceDesktop: 'TXBT36360000',
            priceMobile: 'TXBT36360001',
            offerDesktop: 'TXBT36370000',
            offerMobile: 'TXBT36370001'
          },
          // azureClientId: '061a2c23-9429-4172-abaf-81e1b9ee15a0',
          azureClientId: gxpBat.getAzureClientId(),
          relativeRedirectUrl: '/en/inventory/gxp-sso/' // BOTH en and es use this!
        };

        // Add our search/bundle.js
        $.ajax({
          // url: '//cdn.rticint.deops.toyota.com/static/rti/latest/deploy/search/bundle.js',
          url: gxpBat.rticCDN() + '/static/rti/latest/deploy/search/bundle.js',
          dataType: 'script',
          cache: true
        }).done(function (data, textStatus, jqxhr) {
          window.bat.util.loader.hideLoader();
        }).fail(function (data, textStatus, jqxhr) {
          // console.log('error: ', data);
        });
      }
    },

    /*-------------------------------------------------------------------------------------
    /gxp/inventory-details page.
    User will not end up on this GXP-details page unless they've already
    set a dealer_code cookie AND its RTI, so its safe to just use our dealer_code cookie
    ---------------------------------------------------------------------------------------*/
    RCDetails: {
      init: function () {
        window.bat.util.loader.showLoader();
        var dealer_code = cookies.getItem('dealer_code_rti_code') || getParameterByName('dealerCd');
        var vinProp = getParameterByName('vin'); // '
        var zipProp = SU.getZip(); // '80634'
        var seriesProp = getParameterByName('series'); // 'camry'

        // reusable component viewConfig object, required on page before bundle.js
        window.viewConfig = {
          dealerId: dealer_code,
          vin: vinProp,
          zip: zipProp,
          promoteDesc: true,
          env: gxpBat.getEnviron(),
          backToVlpPath: '/' + tdaConfig.site.context_url + '/inventory/search/?series=' + seriesProp + '&zipcode=' + zipProp + '&dealerCd=' + dealer_code,
          campaignCodes: {
            dealerDesktop: 'TXBT36350000',
            dealerMobile: 'TXBT36350001',
            priceDesktop: 'TXBT36360000',
            priceMobile: 'TXBT36360001',
            offerDesktop: 'TXBT36370000',
            offerMobile: 'TXBT36370001'
          },
          // azureClientId: '061a2c23-9429-4172-abaf-81e1b9ee15a0',
          azureClientId: gxpBat.getAzureClientId(),
          relativeRedirectUrl: '/en/inventory/gxp-sso/', // BOTH en and es use this!
          localSpecialsHref: window.location.origin + window.zipTools.getSiteHomePath() + 'offers/' + seriesProp + '/index.page' // absolute link to similar offers
        };

        // Add our details/bundle.js
        $.ajax({
          url: gxpBat.rticCDN() + '/static/rti/latest/deploy/details/bundle.js',
          dataType: 'script',
          cache: true
        }).done(function (data, textStatus, jqxhr) {
          window.bat.util.loader.hideLoader();
        }).fail(function (data, textStatus, jqxhr) {
          // console.log('error: ', data);
        });
      }
    },

    // Single sign on redirect
    RCsso: {
      init: function () {
        // reusable component viewConfig object, required on page before bundle.js
        window.viewConfig = {
          // azureClientId: '061a2c23-9429-4172-abaf-81e1b9ee15a0',
          azureClientId: gxpBat.getAzureClientId(),
          env: gxpBat.getEnviron()
        };

        $.ajax({
          url: gxpBat.rticCDN() + '/static/rti/latest/deploy/sso-redirect/bundle.js',
          dataType: 'script',
          cache: true
        }).done(function (data, textStatus, jqxhr) {
          window.bat.util.loader.hideLoader();
        }).fail(function (data, textStatus, jqxhr) {
          // console.log('error: ', data);
        });
      }
    }
  }

  $(window).on('loaded', function (e) {
    if (SU.getTDA() === 'CIN10' || SU.getTDA() === 'DVR10' || SU.getTDA() === 'KAC10') {
      cookies.removeItem('dealer_code_rti_temp', '/');
      cookies.removeItem('dealer_gxp_fmp_Entered', '/');
      gxpBat.garage.init();
    }

    gxpBat.garage.zipFlowEnter(); // adds zip flow enter listener
    window.gxpBat = gxpBat; // for testing

    // init each reusable component on specific pages
    if ($('#gxp-rc-search').length) {
      gxpBat.RCsearch.init();
    }

    if ($('#gxp-rc-details').length) {
      gxpBat.RCDetails.init();
    }

    if ($('#gxp-rc-sso').length) {
      gxpBat.RCsso.init();
    }
  });

  return gxpBat;
});

